import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card mb-4" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "card mb-4"
}
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row align-items-end" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 1,
  class: "card mb-4"
}
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = {
  key: 0,
  class: "col-md-6 mb-2 d-flex align-items-center"
}
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "col-md-6 mb-2" }
const _hoisted_16 = { class: "form-group mb-0 d-flex justify-content-end" }
const _hoisted_17 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_18 = {
  key: 1,
  class: "text-info"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_21 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_22 = { key: 6 }
const _hoisted_23 = { class: "row mt-3" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "card mb-4" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "row mb-3" }
const _hoisted_28 = {
  key: 0,
  class: "col-md-6 mb-2 d-flex align-items-center"
}
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = { class: "col-md-6 mb-2" }
const _hoisted_31 = { class: "form-group mb-0 d-flex justify-content-end" }
const _hoisted_32 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_33 = {
  key: 1,
  class: "text-info"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_36 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_37 = { key: 4 }
const _hoisted_38 = { class: "row mt-3" }
const _hoisted_39 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.noteReturn.note_ref), 1),
        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("p", null, [
          _cache[12] || (_cache[12] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.noteReturn.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.getDate(_ctx.noteReturn.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[13] || (_cache[13] = _createTextVNode(" | ", -1)),
          (_ctx.noteReturn.magasin)
            ? (_openBlock(), _createElementBlock("b", _hoisted_4, _toDisplayString(_ctx.noteReturn?.magasin?.market_name), 1))
            : _createCommentVNode("", true),
          _cache[14] || (_cache[14] = _createTextVNode(" (", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.noteReturn.for_name), 1),
          _cache[15] || (_cache[15] = _createTextVNode(") ", -1)),
          (_ctx.noteReturn.city_return)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(" (" + _toDisplayString(_ctx.noteReturn.city_return) + ") ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.noteReturn.statut == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "card-header pb-2" }, [
            _createElementVNode("h5", null, "Scan code suivi")
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.SearchColis && _ctx.SearchColis(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", null, "Code Suivi :", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      placeholder: "Code Suivi",
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.codeColis) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.codeColis]
                    ])
                  ])
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-3" }, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-success mb-2"
                  }, [
                    _createElementVNode("i", { class: "flaticon-plus" })
                  ])
                ], -1)),
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("hr")
                ], -1))
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.noteReturn.statut == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "card-header pb-2" }, [
            _createElementVNode("h3", null, "List des nouveaux colis")
          ], -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-9" }, [
                _createElementVNode("div", { class: "input-group" })
              ], -1)),
              (_ctx.auth.can('ADD_BR_C'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_ctx.noteReturn.statut == 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-success mr-2",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.AddNewColis && _ctx.AddNewColis(...args)))
                        }, " Ajouter "))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.users1.per_page,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.users1.per_page) = $event)),
                      options: [10, 50],
                      clearable: false,
                      class: "mx-2",
                      onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getRows1()))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.users1.total) + " entités", 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    placeholder: "Chercher",
                    type: "text",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.users1.searchTerm) = $event)),
                    onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getRows1()))
                  }, null, 544), [
                    [_vModelText, _ctx.users1.searchTerm]
                  ])
                ])
              ])
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columns,
              rows: _ctx.rows1,
              "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
              onSelectAll: _ctx.onSelectAll,
              onSelectedRowsChange: _ctx.selectionChanged
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [22]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'code')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (props.row.replace == 1)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_17, [
                            _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                            _cache[23] || (_cache[23] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                          ]))
                        : (props.row.partial == 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_18, [
                              _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                              _cache[24] || (_cache[24] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                            ]))
                          : (_openBlock(), _createElementBlock("h6", _hoisted_19, _toDisplayString(props.row.code), 1))
                    ], 64))
                  : (props.column.field === 'status')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (props.row.delivered_by != 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({
                  '--dynamic-bg':
                    _ctx.globalStore.globalHelper('DELIVERED').code_color,
                })
                            }, _toDisplayString(_ctx.globalStore.globalHelper("DELIVERED").name), 5))
                          : _createCommentVNode("", true),
                        (
                props.row.delivered_by == 0 &&
                (props.row.status_second || props.row.status_second != null)
              )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({
                  '--dynamic-bg': _ctx.globalStore.globalHelper(
                    props.row.status_second
                  ).code_color,
                })
                            }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                          : _createCommentVNode("", true),
                        (
                props.row.delivered_by == 0 &&
                (!props.row.status_second || props.row.status_second == null)
              )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                            }, _toDisplayString(props.row.s_name), 5))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (props.column.field === 'price')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                          _cache[25] || (_cache[25] = _createTextVNode(" DH ", -1))
                        ], 64))
                      : (props.column.field === 'received_time')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (props.row.received_time)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.getDate(props.row.received_time)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21))
                          ], 64))
                        : (props.column.field === 'liv_fees')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              (props.row.status == 'DELIVERED')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_livred), 1),
                                    _cache[26] || (_cache[26] = _createTextVNode(" DH ", -1))
                                  ], 64))
                                : _createCommentVNode("", true),
                              (props.row.status == 'REFUSE')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_refused), 1),
                                    _cache[27] || (_cache[27] = _createTextVNode(" DH ", -1))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (props.column.field === 'total')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                (props.row.status == 'DELIVERED')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("b", null, _toDisplayString(props.row.price - props.row.liv_fees_livred), 1),
                                      _cache[28] || (_cache[28] = _createTextVNode(" DH ", -1))
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (props.row.status == 'REFUSE')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("b", null, _toDisplayString(0 - props.row.liv_fees_refused), 1),
                                      _cache[29] || (_cache[29] = _createTextVNode(" DH ", -1))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
            _createElementVNode("div", _hoisted_23, [
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.users1,
                  offset: 9,
                  onPaginate: _ctx.getRows1
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "card-header pb-2" }, [
        _createElementVNode("h5", null, "List des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          (_ctx.auth.can('ADD_BR_C'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_ctx.noteReturn.statut == 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-danger mr-2",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.RemoveNewColis && _ctx.RemoveNewColis(...args)))
                    }, " Supprimer "))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_select, {
                  modelValue: _ctx.users2.per_page,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.users2.per_page) = $event)),
                  options: [10, 25],
                  clearable: false,
                  class: "mx-2",
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getRows2()))
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_29, "sur " + _toDisplayString(_ctx.users2.total) + " entité ", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                placeholder: "Chercher",
                type: "text",
                onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getRows2())),
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.users2.searchTerm) = $event))
              }, null, 544), [
                [_vModelText, _ctx.users2.searchTerm]
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows2,
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis,
          responsive: ""
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[32] || (_cache[32] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [32]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_32, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[33] || (_cache[33] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_33, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[34] || (_cache[34] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_34, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (props.row.delivered_by != 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                  '--dynamic-bg':
                    _ctx.globalStore.globalHelper('DELIVERED').code_color,
                })
                        }, _toDisplayString(_ctx.globalStore.globalHelper("DELIVERED").name), 5))
                      : _createCommentVNode("", true),
                    (
                props.row.delivered_by == 0 &&
                (props.row.status_second || props.row.status_second != null)
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                  '--dynamic-bg': _ctx.globalStore.globalHelper(
                    props.row.status_second
                  ).code_color,
                })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : _createCommentVNode("", true),
                    (
                props.row.delivered_by == 0 &&
                (!props.row.status_second || props.row.status_second == null)
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                      : _createCommentVNode("", true)
                  ], 64))
                : (props.column.field === 'price')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                      _cache[35] || (_cache[35] = _createTextVNode(" DH ", -1))
                    ], 64))
                  : (props.column.field === 'received_time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (props.row.received_time)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.getDate(props.row.received_time)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36))
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
        _createElementVNode("div", _hoisted_38, [
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.users2,
              offset: 9,
              onPaginate: _ctx.getRows2
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ])
      ])
    ])
  ], 64))
}